// Reviewed
import React, { Component } from "react";
import { Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import {
  RetrieveCategories,
  StoreCategories,
} from "../../Helper/LocalForgeHelper";
import axios from "axios";
import { SelectCategoryURL } from "../../APIServices/SelectCategoryRequest";
import SessionHelper from "../../Helper/SessionHelper";
import { Redirect } from "react-router";
import { CartListCountURL } from "../../APIServices/CartListCount";
import { RequiredSearchKey } from "../../Helper/ToastMassageHelper";

import rajMangoLogo from "../../Assets/Img/mainlogo.svg";

class TopNavigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      DataList: null,
      Redirect: false,
      cartItem: 0,
      searchKey: "",
      searchRedirect: false,
      showSideMenu: false,
    };
  }

  showSidebar = () => {
    this.setState({ showSideMenu: true });
    console.log("Show");
  };

  hideSidebar = () => {
    this.setState({ showSideMenu: false });
  };

  componentDidMount() {
    this.SelectCategory();
    this.cartItemCount();
  }
  SelectCategory = () => {
    RetrieveCategories((StoreData) => {
      if (StoreData !== null) {
        this.setState({ DataList: StoreData });
      } else {
        axios.get(SelectCategoryURL()).then((res) => {
          this.setState({ DataList: res.data.categories });
          StoreCategories(res.data.categories);
        });
      }
    });
  };
  logOut = () => {
    SessionHelper.ClearAllSession();
    this.setState({ Redirect: true });
  };
  pageRedirect = () => {
    if (this.state.Redirect === true) {
      return <Redirect to="/" />;
    }
  };
  cartItemCount() {
    axios.get(CartListCountURL()).then((res) => {
      this.setState({ cartItem: res.data });
    });
  }
  search = (e) => {
    e.preventDefault();
    let searchKey = this.state.searchKey;
    if (searchKey.length === 0) {
      RequiredSearchKey();
    } else {
      this.setState({ searchRedirect: true });
    }
  };

  searchRedirectPage = () => {
    if (this.state.searchRedirect === true) {
      return <Redirect to={"/search/" + this.state.searchKey} />;
    }
  };

  render() {
    let isHome = window.location.pathname === "/";
    let CategoryList = this.state.DataList;
    let CategoryListView = <Nav.Link> </Nav.Link>;
    if (CategoryList !== null) {
      CategoryListView = CategoryList.map((list, i) => {
        return (
          <li className="nav-item" key={i}>
            <NavLink
              exact
              className="nav-link mx-1"
              to={"/ProductList/" + list["cat_code"]}
            >
              {list["cat_name"]}
            </NavLink>
          </li>
        );
      });
    }
    let LoginStatus = SessionHelper.getLogin();

    return (
      <>
        <nav
          id="WebMenu"
          className={`navbar navbar-expand-lg bg-${
            isHome ? "tranparent" : "white"
          } i fixed-top`}
        >
          <div className="container">
            <button
              id="SidebarActionBtn"
              data-bs-toggle="offcanvas"
              data-bs-target="#sideMenu"
              className="navbar-toggler "
              onClick={this.showSidebar}
            >
              <span className="fas fa-bars text-dark"></span>
            </button>
            <div className="collapse navbar-collapse" id="collapsibleNavbar">
              <ul className="navbar-nav align-items-center">
                <li className="nav-item">
                  <NavLink to={"/"} className="nav-link">
                    <img height="70px" src={rajMangoLogo} />
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink to={"/"} className="nav-link">
                    হোম
                  </NavLink>
                </li>
                {CategoryListView}
              </ul>
            </div>
            <ul className="menu-fixed navbar-nav  justify-content-end align-items-center ">
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to={"/NotificationList"}
                  title="বার্তা"
                >
                  <i className="fa-solid fa-bell"></i>
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  style={{ marginRight: 10 }}
                  className="nav-link position-relative"
                  to={"/CartList"}
                >
                  <i className="fa-solid fa-shopping-cart"></i>

                  <span
                    className="position-absolute bg-warning text-white rounded-circle"
                    style={{
                      top: "-5px",
                      right: "-5px",
                      fontSize: "14px",
                      height: 20,
                      width: 20,
                      textAlign: "center",
                      verticalAlign: "middle",
                    }}
                  >
                    {this.state.cartItem}
                  </span>
                </NavLink>
              </li>

              {LoginStatus ? (
                <>
                  <li className="nav-item">
                    <NavLink
                      className="nav-link"
                      to={"/fav"}
                      title="পছন্দের তালিকা"
                    >
                      <i className="fa-solid fa-heart"></i>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink
                      className="nav-link"
                      to={"/orderHistory"}
                      title="অর্ডার সমুহ"
                    >
                      <i className="fa-solid fa-bag-shopping"></i>
                    </NavLink>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="#"
                      onClick={this.logOut}
                      title="লগ-আউট"
                    >
                      <i className="fa-solid fa-sign-out"></i>
                    </a>
                  </li>
                </>
              ) : (
                <>
                  {" "}
                  <li className="nav-item">
                    <NavLink className="nav-link" to={"/Login"} title="লগইন">
                      <i className="fa-solid fa-sign-in"></i>
                    </NavLink>
                  </li>
                </>
              )}

              <li className="nav-item">
                <form onSubmit={this.search} className="d-flex">
                  <input
                    onChange={(e) => {
                      this.setState({ searchKey: e.target.value });
                    }}
                    type="text"
                    className="form-control rounded-0"
                    placeholder="আপনি কি খুজছেন ?"
                  />
                  <button
                    className="btn btn-warning rounded-0 text-white"
                  >
                    খুজুন
                  </button>
                </form>
              </li>
            </ul>
          </div>
        </nav>

        <div id="WebSideMenu" className={this.state.showSideMenu || "d-none"}>
          <div className="offcanvas offcanvas-start" id="sideMenu">
            <div className="offcanvas-header">
              <NavLink
                style={{ marginLeft: "-30px" }}
                className="nav-link p-0"
                to={"/"}
              >
                <img height="70px" src={rajMangoLogo} />
              </NavLink>
            </div>
            <div className="offcanvas-body">
              <ul className="navbar-nav">
                <li className="nav-item">
                  <NavLink to={"/"} className="nav-link">
                    হোম
                  </NavLink>
                </li>
                {CategoryListView}
              </ul>
              <ul className="navbar-nav d-block d-sm-none">
                <hr style={{ border: "1px solid gray" }} />
                <li className="nav-item">
                  <NavLink className="pt-0 nav-link" to={"/HowPurchase"}>
                    <i className="fa-solid fa-circle-arrow-right"></i> কিভাবে
                    কিনবেন
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="pt-0 nav-link" to={"/About"}>
                    <i className="fa-solid fa-circle-arrow-right"></i> আমাদের
                    সম্পর্কে
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to={"/Contact"}>
                    <i className="fa-solid fa-circle-arrow-right"></i> যোগাযোগ
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to={"/Privacy"}>
                    <i className="fa-solid fa-circle-arrow-right"></i> প্রাইভেসি
                    পলিসি
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to={"/Terms"}>
                    <i className="fa-solid fa-circle-arrow-right"></i> শর্ত সমুহ
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to={"/Refund"}>
                    <i className="fa-solid fa-circle-arrow-right"></i> ফেরত নীতি
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
          <div
            onClick={this.hideSidebar}
            id="NoSidebar"
            className="text-start"
          ></div>
        </div>
        {this.state.searchRedirect && this.searchRedirectPage()}
      </>
    );
  }
}
export default TopNavigation;
